import { render } from "./Closing.vue?vue&type=template&id=fa217c2c"
import script from "./Closing.vue?vue&type=script&lang=js"
export * from "./Closing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__